document.addEventListener("DOMContentLoaded", function() {

    $(document).on("click", ".js-toggle-subsections", function(e){

        const $el = $(e.target);
        const section = $el.closest(".section");

        section.toggleClass("opened");
    });
});




